import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dataTypeSelect", 
    "optionsSection", 
    "unitOfMeasureSection",
    "optionsListTextarea"
  ]

  connect() {
    // Initialize form state
    this.updateDataType()
  }

  updateDataType() {
    const dataType = this.dataTypeSelectTarget.value
    
    // Hide all sections first
    this.hideAllSections()
    
    // Show relevant sections based on data type
    if (this.requiresOptions(dataType)) {
      this.showOptionsSection()
    }
    
    if (this.isNumericType(dataType)) {
      this.showUnitOfMeasureSection()
    }
  }

  hideAllSections() {
    if (this.hasOptionsSectionTarget) {
      this.optionsSectionTarget.classList.add('hidden')
    }
    if (this.hasUnitOfMeasureSectionTarget) {
      this.unitOfMeasureSectionTarget.classList.add('hidden')
    }
  }

  showOptionsSection() {
    if (this.hasOptionsSectionTarget) {
      this.optionsSectionTarget.classList.remove('hidden')
    }
  }

  showUnitOfMeasureSection() {
    if (this.hasUnitOfMeasureSectionTarget) {
      this.unitOfMeasureSectionTarget.classList.remove('hidden')
    }
  }

  requiresOptions(dataType) {
    return ['select', 'multi_select'].includes(dataType)
  }

  isNumericType(dataType) {
    return ['integer', 'float'].includes(dataType)
  }

  // Helper method to add option to select lists
  addSelectOption(event) {
    if (event.key === 'Enter' && event.ctrlKey) {
      event.preventDefault()
      const textarea = this.optionsListTextareaTarget
      const currentValue = textarea.value
      textarea.value = currentValue + (currentValue ? '\n' : '') + 'New Option'
      textarea.focus()
      // Select the new option text
      const lines = textarea.value.split('\n')
      const lastLineStart = textarea.value.lastIndexOf('\n') + 1
      textarea.setSelectionRange(lastLineStart, textarea.value.length)
    }
  }
} 